// React
import { useState } from 'react'

// Styles
import './Column.css'

// Components
import Card from './Card'

const Column = ({
  columnId,
  columnName,
  cards = [],
  onAddCard,
  onEditCard,
  onDeleteCard,
  onRenameColumn,
  onDeleteColumn,
  onDragStart,
  onDrop,
}) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [isDragOver, setIsDragOver] = useState(false)

  const handleDragOver = (e) => {
    e.preventDefault()
    setIsDragOver(true)
  }

  const handleDragLeave = () => {
    setIsDragOver(false)
  }

  const handleDrop = (e) => {
    e.preventDefault()
    setIsDragOver(false)
    onDrop(columnId)
  }

  return (
    <div
      className={`Column${isDragOver ? ' Column--drag-over' : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <div className='Column-header'>
        <h1>{columnName}</h1>
        <div className='Column-header-actions'>
          <div className='Column-add-btn-wrapper'>
            <button
              className='Column-add-btn'
              onClick={onAddCard}
              disabled={cards.length >= 3}
            >
              +
            </button>
            {cards.length >= 3 && (
              <span className='Column-add-tooltip'>Limite de 3 cards atingido</span>
            )}
          </div>
          <div className='Column-menu-wrapper'>
            <button
              className='Column-menu-btn'
              onClick={() => setMenuOpen(prev => !prev)}
            >
              ⋯
            </button>
            {menuOpen && (
              <>
                <div className='Column-menu-backdrop' onClick={() => setMenuOpen(false)} />
                <div className='Column-menu'>
                  <button onClick={() => { onRenameColumn(); setMenuOpen(false) }}>
                    ✏️ Renomear
                  </button>
                  <button className='danger' onClick={() => { onDeleteColumn(); setMenuOpen(false) }}>
                    🗑️ Excluir coluna
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className='Column-cards'>
        {cards.map(card => (
          <Card
              key={card.numCard}
              title={card.title}
              description={card.description}
              onEdit={() => onEditCard(card)}
              onDelete={() => onDeleteCard(card.numCard)}
              onDragStart={() => onDragStart(card.numCard, columnId)}
          />
        ))}
      </div>
    </div>
  )
}

export default Column